import { render } from "./QPlus.vue?vue&type=template&id=e854a7e6"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/QPlus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e854a7e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e854a7e6', __exports__)) {
    api.reload('e854a7e6', __exports__)
  }
  
  module.hot.accept("./QPlus.vue?vue&type=template&id=e854a7e6", () => {
    api.rerender('e854a7e6', render)
  })

}


export default __exports__